const publicUrl = process.env.PUBLIC_URL || '';

export const brandAssets = {
  logos: {
    horizontalColor400: `${publicUrl}/brand/web/pulsora-logo-horizontal-color-400.png`,
    horizontalColor800: `${publicUrl}/brand/web/pulsora-logo-horizontal-color-800.png`,
    horizontalColor1200: `${publicUrl}/brand/web/pulsora-logo-horizontal-color-1200.png`,
    horizontalColor2048: `${publicUrl}/brand/web/pulsora-logo-horizontal-color-2048.png`,
    horizontalNavy: `${publicUrl}/brand/web/pulsora-logo-horizontal-navy-1200.png`,
    horizontalWhite: `${publicUrl}/brand/web/pulsora-logo-horizontal-white-1200.png`,
    darkBackground: `${publicUrl}/brand/web/pulsora-logo-horizontal-dark-bg.png`,
    lightBackground: `${publicUrl}/brand/web/pulsora-logo-horizontal-light-bg.png`,
    loginTransparent: `${publicUrl}/brand/web/pulsora-logo-horizontal-dark-bg.png`,
    verticalColor: `${publicUrl}/brand/apps/pulsora-logo-vertical-color-1024.png`,
    verticalWhite: `${publicUrl}/brand/apps/pulsora-logo-vertical-white-1024.png`,
    monogram: `${publicUrl}/pulsora-icon-master-1024.png`,
  },
  app: {
    splashLight: `${publicUrl}/brand/apps/pulsora-splash-light-2048.png`,
    splashDark: `${publicUrl}/brand/apps/pulsora-splash-dark-2048.png`,
    icon192: `${publicUrl}/android-chrome-192x192.png`,
    icon512: `${publicUrl}/pulsora-icon-512.png`,
    appleTouchIcon: `${publicUrl}/apple-touch-icon.png`,
  },
  social: {
    openGraph: `${publicUrl}/brand/social/pulsora-open-graph-1200x630.png`,
    profile: `${publicUrl}/brand/social/pulsora-profile-dark-1080.png`,
    squareDark: `${publicUrl}/brand/social/pulsora-post-square-dark-1080.png`,
    squareLight: `${publicUrl}/brand/social/pulsora-post-square-light-1080.png`,
    cover: `${publicUrl}/brand/social/pulsora-cover-1500x500.png`,
  },
};
